import type { ArticlesSearchFilterByDateRange } from "scmp-app/components/search/contexts";

import { getTimeRangeForDays } from "./helpers";

export const AllDateRangeOption: {
  text: string;
  value: ArticlesSearchFilterByDateRange;
} = {
  text: "All",
  value: {},
};

export const DateRangeOptions: {
  text: string;
  value: ArticlesSearchFilterByDateRange;
}[] = [
  {
    text: "Past 24 Hours",
    value: getTimeRangeForDays(1),
  },
  {
    text: "7 Days",
    value: getTimeRangeForDays(7),
  },
  {
    text: "60 Days",
    value: getTimeRangeForDays(60),
  },
  {
    text: "12 Months",
    value: getTimeRangeForDays(365),
  },
  {
    ...AllDateRangeOption,
  },
];
